import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { ratelimitClient } from '#pplx_generated/typespec/rest/ratelimit/client.js';
export const rateLimitStatusesQuery = {
    getKey: () => QueryClientHelper.makeQueryKey('/rest/rate-limit/all', {}),
    getOptions: ({ reason }, requestParams, overrideOptions) => ({
        queryKey: rateLimitStatusesQuery.getKey(requestParams),
        queryFn: async () => {
            const { data, error, response } = await ratelimitClient.GET('/rest/rate-limit/status', reason);
            if (error || !data) {
                throw new ApiClientsError('API_CLIENTS_ERROR', {
                    message: 'Failed to get rate limit statuses',
                    cause: error,
                    status: response.status,
                });
            }
            return data;
        },
        ...overrideOptions,
    }),
};
//# sourceMappingURL=rateLimitStatusesQuery.js.map